import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './PaymentForm.css';
import axiosApi from '../../../api/daonAxios';

const PaymentRegister = () => {

  const location = useLocation();

  const paramData = location.state || undefined;

  // 쿼리 파라미터 파싱
  const query = useMemo(() => new URLSearchParams(location.search), [location.search]);

  const telMdcApplID = query.get('telMdcApplID') || paramData?.telmdcApplId || '';
  const hsptlCd      = query.get('hsptlCd')  || paramData?.hsptlCd    || '';
  const deptCd       = query.get('deptCd')   || paramData?.deptCd    || '';
  const patntNo      = query.get('patntNo')  || paramData?.patntNo    || '';
  const amountParam  = query.get('amount')   || paramData?.amount    || '0';
  const amount       = Number(amountParam) || 0;
  const telmdcSchdulId = paramData?.telmdcSchdulId || '';

  const autoPayCalledRef = useRef(false);

  const [productName] = useState('Consultation Fee');
  const [productAmount] = useState(amount);

  const pay = async () => {
      const isMobile = /Mobi|Android/i.test(navigator.userAgent);
      // paramData가 있으면 현재 창 사용하도록..

      if (paramData) {
          try {
              const { data } = await axiosApi.post('/payment/easypay/register', {
                  orderNo: 'ORD-' + Date.now(),
                  amount,
                  mobile: isMobile,
                  telMdcApplID,
                  hsptlCd,
                  deptCd,
                  patntNo,
                  telmdcSchdulId,
              });
              if (data?.authPageUrl) {
                  window.location.href = data.authPageUrl;
              } else {
                  alert('Failed to register payment.');
              }
          } catch (e) {
              alert('Failed to open payment window : ' + (e?.response?.data?.body || 'Unknown error'));
          }
          return;
      }
      // === 기존 로직: paramData 가 없을 때만 팝업 사용 ===
      const popup = window.open('', '_blank', 'width=520,height=700');
      try {
          const { data } = await axiosApi.post('/payment/easypay/register', {
              orderNo: 'ORD-' + Date.now(),
              amount,
              mobile: isMobile,
              telMdcApplID,
              hsptlCd,
              deptCd,
              patntNo,
              telmdcSchdulId,
          });
          if (data?.authPageUrl) {
              if (isMobile) {
                  // 모바일은 팝업 대신 전체 리다이렉트
                  window.location.href = data.authPageUrl;
              } else if (popup && !popup.closed) {
                  popup.location.assign(data.authPageUrl);
              } else {
                  // 팝업이 차단된 경우 폴백
                  window.location.href = data.authPageUrl;
              }
          } else {
              if (popup && !popup.closed) popup.close();
              alert('Failed to register payment.');
          }
      } catch (e) {
          if (popup && !popup.closed) popup.close();
          alert('Failed to open payment window : ' + (e?.response?.data?.body || 'Unknown error'));
      }
  };

  useEffect(() => {
    // 필수 파라미터 없거나 금액 0이면 자동호출 안함 (원하는대로 조건 조절 가능)
    if (!telMdcApplID || !deptCd || !hsptlCd || !patntNo || amount <= 0) return;
    if (autoPayCalledRef.current) return; // 한 번만 실행

    autoPayCalledRef.current = true;
    pay();
  }, [telMdcApplID, hsptlCd, patntNo, amount, deptCd]); // 필요한 값들 의존성

  // return <button onClick={pay}>결제하기</button>;
  return (
    <div className="payment-container">
      {/* <h3>🧾 주문내역</h3> */}
      <div className="section-box">
        {/*
        <div className="section-box">
          <label>병원코드</label>
          <input type="text" value={hsptlCd} readOnly />

          <label>부서코드</label>
          <input type="text" value={deptCd} readOnly  />

          <label>진료신청 ID</label>
          <input type="text" value={telMdcApplID} readOnly />

          <label>환자번호</label>
          <input type="text" value={patntNo} readOnly />

          <label>상품명</label>
          <input type="text" value={productName} readOnly />

          <label>결제금액</label>
          <input type="text" value={productAmount.toLocaleString() + '원'} readOnly />
        </div>
        */}

        {/* <label>상품명</label>
        <input type="text" value={productName} readOnly /> */}

        <label>Consultation Fee</label>
        <input type="text" value={productAmount} readOnly />
      </div>

      <button className="submit-btn" onClick={pay}>Request Payment Manually</button>
    </div>
  )
};

export default PaymentRegister;
